<template>
  <div>
    <section
      v-show="!showFbPageSelect"
      class="create-merchant-sec">
      <h1 class="create-merchant-sec__title">Create Merchant Account</h1>
      <img
        class="create-merchant-sec__social-logo"
        src="~@/assets/img/whatsapp.svg">
      <div class="create-merchant-sec__input-title create-merchant-sec__input-title--soc">
        WhatsApp
      </div>
      <div class="create-merchant-sec__input-sub-title">
        To enable WhatsApp add your WhatsApp number below
      </div>
      <PhoneInput
        :value="phone"
        @onInput="onInput"/>
      <div
        v-if="validationErrors.phone && validationErrors.phone.length"
        class="create-merchant__error">{{ validationErrors.phone }}</div>
      <img
        class="create-merchant-sec__social-logo"
        src="~@/assets/img/messenger.svg">
      <div class="create-merchant-sec__input-title create-merchant-sec__input-title--soc">
        Messenger
      </div>
      <div class="create-merchant-sec__input-sub-title">
        To enable Messenger authorize your Facebook account and connect page
      </div>
      <b-input-group
        :prepend="fbPageConnected ? 'Connected' : 'Connect'"
        class="create-merchant-sec__input-group create-merchant-sec__input-group--soc">
        <div class="form-control create-merchant-sec__soc-btn">
          <img
            :src="`/static/img/fb/${fbPageConnected ? 'icon-dark' : 'icon-lite'}.svg`">
          <span
            :class="{connected : fbPageConnected}"
            class="page-name"
            @click="checkLoginState">
            {{ fbPageConnected ? fbPage.page.name : 'Facebook Page' }}
          </span>
          <span v-if="fbPageConnected">
            <icon
              name="circle"
              width="4"
              height="4"
              class="dot-icon"/>
            <span
              class="fb-page-delete"
              @click="deleteFacebookPage">
              Delete
            </span>
          </span>
        </div>
        <div
          v-if="fbPageConnected"
          slot="append"
          class="create-merchant-sec__input-checked">
          <img
            src="~@/assets/img/done.svg"
            alt="Done">
        </div>
      </b-input-group>
      <div
        v-if="validationErrors.facebook && validationErrors.facebook.length"
        class="create-merchant__error">{{ validationErrors.facebook }}</div>
      <div
        class="create-merchant-sec__alert">
        <template v-if="errorMessage.length">
          {{ errorMessage }}
        </template>
      </div>
      <b-button
        :disabled="disableButton"
        block
        class="create-merchant-sec__submit create-merchant-sec__submit--soc"
        @click="goNext">Continue to Business details</b-button>
      <b-button
        block
        class="create-merchant-sec__submit--back"
        @click="goBack">Back</b-button>
    </section>
    <FbPageList
      v-if="showFbPageSelect"
      :pagesp="fbPageList"
      @connectPage="connectFacebookPage"/>
  </div>
</template>

<script>
import setValidationErrors from '@/helpers/validationErrors';
import { insertScriptTag } from '@/helpers/scriptInjection';
import PhoneInput from '../../common/PhoneInput';
import FbPageList from '../partials/fb/FbPageList';
import { mapGetters } from 'vuex';

export default {
  name: 'CreateMerchantStep1',
  components: {
    PhoneInput,
    FbPageList,
  },
  props: {
    whatsappp: {
      type: Object,
      default: () => {},
    },
    facebookp: {
      type: Object,
      default() {
        return {
          admin: {
            id: '',
            first_name: '',
            last_name: '',
          },
          page: {
            id: '',
            name: '',
            picture: '',
          },
        };
      },
    },
  },
  data() {
    return {
      phone: '',
      fbMessenger: '',
      errorMessage: '',
      phoneValid: false,
      fbPageList: '',
      showFbPageSelect: false,
      fbPageConnected: false,
      fbPage: {},
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      facebookAppId: 'system/facebookAppId',
    }),
    disableButton() {
      return !(this.phoneValid || this.fbPageConnected);
    },
  },
  created() {
    if (!this.$lodash.isEmpty(this.facebookp)) {
      this.fbPageConnected = true;
      this.fbPage = this.facebookp;
    }

    if (!this.$lodash.isEmpty(this.whatsappp)) {
      this.fbPageConnected = true;
      this.phone = this.whatsappp.account.phone;
    }

    window.fbAsyncInit = () => {
      // eslint-disable-next-line no-undef
      if (this.facebookAppId) {
        window.FB.init({
          appId: this.facebookAppId,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v3.0',
        });
      }
    };

    insertScriptTag('facebook-jssdk', 'https://connect.facebook.net/en_US/sdk.js');
  },
  methods: {
    checkLoginState() {
      if (this.fbPageConnected) {
        return false;
      }
      window.FB.login((response) => {
        if (response.status === 'connected') {
          this.loadPageAdmin();
          this.loadPages();
        }
      }, {
        scope: 'public_profile,email,manage_pages,pages_show_list,read_page_mailboxes,pages_messaging,pages_messaging_phone_number,pages_messaging_subscriptions',
      });

      return true;
    },
    loadPageAdmin() {
      window.FB.api('/me', (response) => {
        const firstName = response.name.substr(0, response.name.indexOf(' '));
        const lastName = response.name.substr(response.name.indexOf(' ')).trim();
        this.fbPage.admin = {
          first_name: firstName,
          last_name: lastName,
          id: response.id,
        };
      });
    },
    loadPages() {
      window.FB.api('/me/accounts?limit=100', (response) => {
        this.fbPageList = this.$lodash.filter(response.data, page => page.perms.includes('ADMINISTER'));
        this.showFbPageSelect = true;
      });
    },
    connectFacebookPage(page) {
      this.fbPage.page = page;
      this.showFbPageSelect = false;
      this.fbPageConnected = true;
    },
    deleteFacebookPage() {
      this.fbPage = {};
      this.fbPageConnected = false;
      this.validationErrors.facebook = '';
    },
    onInput({ number, isValid }) {
      // eslint-disable-next-line no-console
      this.phoneValid = isValid;
      this.phone = number;
      this.validationErrors.phone = '';
    },
    goBack() {
      this.$router.push({ name: 'BusinessList' });
    },
    goNext() {
      const whatsapp = this.phone.length ? {
        account: {
          phone: this.phone,
        },
      } : {};
      const payload = {
        whatsapp,
        facebook: this.fbPage,
      };
      this.$api('POST', '/validations/merchants/social-platforms', { social_platforms: payload })
        .then((response) => {
          if (response.status === 200) {
            this.$emit('goNext', payload);
          }
        })
        .catch((errors) => {
          this.validationErrors = setValidationErrors(errors.response.data.errors, {
            'social_platforms.whatsapp.account.phone': 'phone',
            'social_platforms.facebook.page.id': 'facebook',
          });
        });
    },
  },
};
</script>
